export enum RoleEnum {
  ADMINISTRATOR = 'ADMINISTRATOR',
  MANAGER = 'MANAGER',
  MEMBER = 'MEMBER',
}
